import { render } from "./HomeSection8.vue?vue&type=template&id=90b085de&scoped=true"
import script from "./HomeSection8.vue?vue&type=script&lang=js"
export * from "./HomeSection8.vue?vue&type=script&lang=js"

import "./HomeSection8.vue?vue&type=style&index=0&id=90b085de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b085de"]])

export default __exports__